<div class="roi-bar" [ngClass]="{ compact }">
  <span class="roi-bar__score">{{ label }}</span>
  @if (score !== null && score !== undefined) {
    <div class="roi-bar__track">
      <div class="roi-bar__fill" [style.width.%]="percent"></div>
    </div>
  }
</div>
